import * as yup from 'yup';

export const auditDynamicFormSchema = yup.object().shape({
  action: yup.string().required('Action is required'),
  confidence_score: yup
    .number()
    .min(0)
    .max(100)
    .required('Confidence score is required'),
  notes: yup.string(),
  shift_date: yup.string().required('Shift date is required'),
  shift_start_time: yup.string().required('Shift start time is required'),
  shift_end_time: yup.string().required('Shift end time is required'),
  retailer_id: yup.string().required('Retailer ID is required'),
  ticket_details: yup
    .array()
    .of(
      yup.object().shape({
        game: yup
          .string()
          .required('Game is required')
          .min(4, 'Invalid Game')
          .max(4, 'Invalid Game'),
        name: yup.string().required('Name is required'),
        pack: yup
          .string()
          .required('Pack is required')
          .min(7, 'Invalid Pack')
          .max(7, 'Invalid Pack'),
        range: yup
          .string()
          .required('Range is required')
          .min(7, 'Invalid min Range')
          .max(7, 'Invalid max Range'),
      }),
    )
    .min(1, 'At least one ticket detail is required')
    .test('games-in-ascending-order', 'Games must be in ascending order', function (value) {
      if (!value || value.length <= 1) {
        return true;
      }

      const games = value
        .map((ticket: any) => ticket.game)
        .filter((game: string) => game && game.length === 4)
        .map((game: string) => parseInt(game, 10))
        .filter((num: number) => !isNaN(num));

      if (games.length <= 1) {
        return true;
      }

      for (let index = 1; index < games.length; index += 1) {
        if (games[index] < games[index - 1]) {
          return this.createError({
            message: `Game ${games[index]} should be greater or equal to ${games[index - 1]}. Games must be in ascending order.`,
          });
        }
      }

      return true;
    }),
});
